import React, { useEffect, useState } from "react";
import PathInfo from "../../model/PathInfo";
import ChemiNovaEntityType from "../../model/enums/ChemiNovaEntityType";
import chemiNovaEntityTypeDisplay from "../../utils/ChemiNovaEntityTypeDisplay";
import uiSectionByEntityType from "../../utils/UISectionByEntityType";
import { useNavigate } from "react-router-dom";
import SETTINGS from "../../globals";
import AppSubSections from "../../utils/AppSubSections";
import { useAlerts } from "../../contexts/AlertsContext";
import { useAppDispatch } from "../../redux/hooks";
import { update } from "../../redux/slices/groupExplorerActiveAssetID";

interface IPathDisplayProps {
  data: PathInfo | undefined;
}

function PathDisplay({ data }: IPathDisplayProps) {
  const pathAsArray: PathInfo[] = [];
  // reference to the navigator
  const navigate = useNavigate();
  // reference to the alertsManager to provide insights on the paths
  const alertsManager = useAlerts();
  // redux setup to update the current CH Asset ID
  const dispatch = useAppDispatch();

  useEffect(() => {
    return () => {
      dispatch(update(-1));
    };
  }, []);

  const pathToArray = (info: PathInfo) => {
    if (info.parent) {
      pathToArray(info.parent);
    }
    //HACK for e3Ds
    if (!info.entity_type) {
      info.entity_type = ChemiNovaEntityType.E3DMODEL;
    }
    pathAsArray.push(info);
    // check if the current element is of type CHElement
    if (info.entity_type === ChemiNovaEntityType.CHELEMENT) {
      dispatch(update(info.id));
    }
  };

  if (data) {
    pathToArray(data);
    // add the entry for home = search
    pathAsArray.splice(
      0,
      0,
      new PathInfo(0, "SEARCH", ChemiNovaEntityType.SEARCH)
    );
    pathAsArray.reverse();
  }

  const pathItemClicked = (index: number) => {
    const clickedItem = pathAsArray[index];
    const section = uiSectionByEntityType(clickedItem.entity_type);

    // we navigate only if we have a valid section to navigate to
    if (section) {
      const params = clickedItem.id
        ? {
            section: section,
            id: clickedItem.id,
            subsection: AppSubSections.VIEW,
          }
        : { section: section };
      navigate(SETTINGS.get_path(params));
    }
  };

  if (pathAsArray.length == 0) {
    return null;
  }

  return (
    <div className="path-container">
      <div>
        {false && (
          <div className="path-you-are-here">
            You are
            <br />
            here!
          </div>
        )}
        <div className="path-content">
          {pathAsArray.map((item, index) => {
            let css =
              index < pathAsArray.length - 1
                ? "arrow-head arrow-rear"
                : "arrow-head";

            css += item.notActiveLink ? " not-active" : "";

            return (
              <div
                onClick={() => pathItemClicked(index)}
                className={css}
                key={"key_" + index}
              >
                <span>
                  {chemiNovaEntityTypeDisplay(item.entity_type, false)}
                </span>
                {item.name}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default PathDisplay;
